'use client';

import { SessionCountDown } from '@/components/SessionCountDown';
import { LinkLoadingIndicatorWrapper } from '@/components/link-loading-wrapper';
import ReactQueryProvider from '@/providers/react-query-provider';
import { SessionProvider } from '@hono/auth-js/react';
import { Toaster } from 'sonner';

export default function Layout({ children }: { children: React.ReactNode }) {

  return (
    <SessionProvider refetchInterval={1000} refetchOnWindowFocus={false}>
      <ReactQueryProvider>

        {children}
        <SessionCountDown />
        {/* <OfflineIndicator /> */}
        <Toaster richColors />
        <LinkLoadingIndicatorWrapper />
      </ReactQueryProvider>
    </SessionProvider>
  );
}
